import React, { useState, useEffect } from 'react';
import {
    Box,
    Tooltip,
    Chip,
    Grid,
    Stack,
    Select,
    Typography,
    TextField,
    IconButton,
    MenuItem,
    InputAdornment
} from '@mui/material'
import { Add, Download, Delete, Replay, Search, Create } from '@mui/icons-material'
import Tables from '@components/table';
import apiService from '@services/common'
import { useGlobalContext } from '@providers/globalProvider';
import AddDrawer from './addDrawer';
import EditDrawer from './editDrawer';

import { saveAs } from 'file-saver';
import { dataToFormData } from '@utils/common'
import { useSelector, useDispatch } from 'react-redux'
import { updateBreadcrumb } from '@redux/commonReducer'
import { uploadUrl } from "@services/axios";

const Post = () => {
    const [data, setData] = useState([])
    const [keyword, setKeyword] = useState('')
    const [selectedRows, setSelectedRows] = useState([])
    const { showNotification, showLoading, hideLoading, openModal, closeModal, openDrawer, closeDrawer, showConfirm, closeConfirm } = useGlobalContext()
    const dispatch = useDispatch()
    const columns = [
        {
            field: 'updated_at',
            headerName: '#',
            width: 50,
            editable: false,
            renderCell: (params) => (
                <IconButton
                    onClick={() => handleEdit(params.row)}
                    sx={{ border: 'none', alignItems: 'flex-start' }}
                >
                    <Create />
                </IconButton>)
        },
        {
            field: 'image',
            headerName: 'Ảnh đại diện',
            width: 120,
            editable: false,
            renderCell: (params) =>
                params.value ? (
                    <img
                        src={uploadUrl + params.value}
                        alt="Ảnh đại diện"
                        style={{ width: '100px', height: 'auto', objectFit: 'cover', padding: '5px' }}
                    />
                ) : <img
                    src={'/noimg.jpeg'}
                    alt="Ảnh đại diện"
                    style={{ width: '100px', height: 'auto', objectFit: 'cover', padding: '5px' }}
                />
        },
        {
            field: 'title',
            headerName: 'Tiêu đề',
            width: 300,
            editable: true,
        },
        {
            field: 'category',
            headerName: 'Thuộc danh mục',
            width: 200,
            editable: false,
            renderCell: (params) => (
                <Chip label={params.row?.category?.title} color='secondary' />
            )
        },
        {
            field: 'slug',
            headerName: 'slug',
            width: 300,
            editable: true,
        },
        {
            field: 'is_public',
            headerName: 'Hiển thị',
            width: 100,
            editable: true,
            renderCell: (params) => params.value ? <Chip label="Hiển thị" color="primary" /> : <Chip label="Ẩn" color="error" />,
            renderEditCell: (params) => (
                <Select
                    value={params.value !== undefined ? String(params.value) : ""}
                    onChange={(event) => {
                        const newValue = event.target.value;

                        params.api.setEditCellValue({
                            id: params.id,
                            field: params.field,
                            value: newValue === "1"
                        });
                    }}
                    fullWidth
                >
                    <MenuItem key={1} value="1" selected={params.value === "1"}>
                        Hiển thị
                    </MenuItem>
                    <MenuItem key={0} value="0" selected={params.value === "0"}>
                        Ẩn
                    </MenuItem>
                </Select>
            )
        },
        {
            field: 'created_at',
            headerName: 'Ngày tạo',
            width: 150,
            editable: false,
            renderCell: (params) => new Date(params.value).toLocaleDateString('vi-VN')
        },
    ];

    const breadcrumb =
        [
            {
                name: 'Bài viết',
                url: 'post'
            }
        ]

    const styleButton = {
        backgroundColor: 'transparent',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)'
        },
        border: 'none'
    }

    const handleEdit = (data) => {
        openDrawer({
            content: <EditDrawer submitFunction={doUpdate} data={data} />,
            onCloseCallback: () => { }
        })
    }

    const doUpdate = (data) => {
        delete data.category
        showLoading()
        const formData = dataToFormData(data)

        apiService.putWithMedia(`post/${data.id}`, formData)
            .then(res => {
                loadData()
                hideLoading()
                showNotification(
                    'Gửi đi thành công',
                    'success'
                );
            })
            .catch(err => {
                hideLoading()
                showNotification(err.message, 'error')
            })
    }

    const processRowUpdate = (newRow, oldRow) => {
        showLoading()
        setData((prevRows) =>
            prevRows.map((row) => (row.id === oldRow.id ? { ...newRow } : row))
        )
        apiService.put(`post/${newRow.id}`, newRow)
            .then(res => {
                showNotification("Update thành công", 'success');
                hideLoading()
            })
            .catch(err => {
                showNotification("Đã có lỗi xảy ra, liên hệ quản trị viên để được hỗ trợ", 'error');
                hideLoading()
            })
        return newRow
    }

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            apiService.get(`post?keyword=${keyword}`)
                .then(res => {
                    setData(res.data.data)
                })
                .catch(err => {
                    showNotification("Đã có lỗi xảy ra, liên hệ quản trị viên để được hỗ trợ", 'error');
                })
        }
    }

    const handleAddNew = () => {
        openDrawer({
            content: <AddDrawer submitFunction={doAddNew} />,
            onCloseCallback: () => { }
        })
    }

    const doAddNew = (data) => {
        showLoading()
        console.log("Image file:", data.image);
        console.log("Type:", typeof data.image);
        console.log("Is File:", data.image instanceof File); // Phải là true!

        const formData = dataToFormData(data)
        console.log('====', formData)
        apiService.postWithMedia(`post`, formData)
            .then(res => {
                loadData()
                hideLoading()
                showNotification(
                    'Gửi đi thành công',
                    'success'
                );
            })
            .catch(err => {
                hideLoading()
                showNotification(err.message, 'error')
            })
    }

    const doDelete = () => {
        showLoading()
        apiService.delete(`post/${selectedRows}`)
            .then(res => {
                loadData()
                setSelectedRows([])
                closeConfirm()
                showNotification('Xoá thành công', 'success')
            })
            .catch(err => {
                showNotification(err.message, 'error')
            })
    }

    const handleDelete = () => {
        showConfirm({
            title: 'Xác nhận xóa',
            content: 'Bạn có chắc muốn xoá bản ghi này? Sau khi xoá, dữ liệu có thể không khôi phục lại được',
            onConfirm: () => doDelete(),
            oncancel: () => closeConfirm()
        })
    }



    const loadData = () => {
        showLoading()
        apiService.get('post')
            .then(res => {
                setData(res.data.data)
                hideLoading()
            })
            .catch(err => {
                console.log(err)
                showNotification('Đã có lỗi -  vui lòng liên hệ với quản trị viên', 'error')
                hideLoading()
            })
    }

    const handleChangeKeyword = (e) => {
        setKeyword(e.target.value)
    }

    useEffect(() => {
        loadData()
        dispatch(updateBreadcrumb(breadcrumb))
    }, [])

    return (
        <Box sx={{ width: '100%' }}>
            <Box>
                <Typography variant='h5' sx={{ mb: 2 }}>Quản lý bài viết</Typography>
            </Box>
            <Box>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 6 }} sx={{ mb: 2 }}>
                        <TextField
                            hiddenLabel
                            defaultValue={keyword}
                            onChange={handleChangeKeyword}
                            onKeyDown={handleKeyDown}
                            placeholder="Nhập từ khóa tìm kiếm..."
                            variant="outlined"
                            size="small"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <Search />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Grid>
                    <Grid
                        size={{ xs: 12, md: 6 }}
                        sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}
                    >
                        <Stack direction={'row'} spacing={0}>
                            <Tooltip placement="bottom" content="Thêm mới">
                                <IconButton
                                    sx={styleButton}
                                    onClick={() => handleAddNew()}
                                >
                                    <Add />
                                </IconButton>
                            </Tooltip>
                            <Tooltip placement="bottom" content="Xoá">
                                <IconButton
                                    sx={styleButton}
                                    color="error"
                                    disabled={!(selectedRows.length > 0)}
                                    onClick={() => handleDelete()}
                                >
                                    <Delete />
                                </IconButton>
                            </Tooltip>
                            <Tooltip placement="bottom" content="Export excel">
                                <IconButton
                                    sx={styleButton}
                                    onClick={() => loadData()}
                                >
                                    <Replay />
                                </IconButton>
                            </Tooltip>

                        </Stack>
                    </Grid>
                </Grid>
            </Box>
            <Box>
                {data &&
                    data.length > 0 &&
                    <Tables
                        rows={data}
                        columns={columns}
                        selectedRows={selectedRows}
                        setSelectedRows={setSelectedRows}
                        processRowUpdate={processRowUpdate} />
                }
            </Box>
        </Box>
    );
}

export default Post;